import { Injectable } from '@angular/core';
import { Constants } from '../constants';
import {BusinessUnitDto} from 'src/app/core/interfaces/loggedInUserDto';
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  hasfilteredPermissionList = null;
  businessUnits: any;

  get filteredPermissionList() {
    return this.hasfilteredPermissionList;
  }
  set filteredPermissionList(val) {
    this.hasfilteredPermissionList = val;
  }

  public setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  public getItem(key: string) {
    return localStorage.getItem(key);
  }

  public clear() {
    localStorage.clear();
  }

  public removeItem(key: string) {
    localStorage.removeItem(key);
  }

  public key(index: number) {
    return localStorage.key(index);
  }

  public GetClaimsTransformed(claims): string[] {
    const results = [];
    let permissionarr = JSON.parse(this.getItem('transformpermission'));
    const validBuLevelPerm = this.getBuLevelPermission();
    const permission = (validBuLevelPerm.length) ?
      claims.split(',').filter(x => validBuLevelPerm.includes(x.trim())) : claims.split(',');
    permissionarr = (validBuLevelPerm.length) ?
      permissionarr.filter(x => validBuLevelPerm.includes(x.shortvalue.trim())) : permissionarr;
    this.filteredPermissionList = permissionarr;
    for (const value of permission) {
      const idx = permissionarr.findIndex(elem => elem.shortvalue === value.trim());
      if (idx > -1) {
        results.push(permissionarr[idx].value.trim());
      } else {
        results.push(value.trim());
      }
    }
    return results;
  }

  public hasDPTORCTX(): boolean {
    this.businessUnits = JSON.parse(this.getItem(Constants.LOGGED_IN_USER_INFO)).businessUnits;
    if (this.businessUnits.length) {
      const hasIndex = this.businessUnits
        .findIndex(x => (x.buCode === 'DPT' || x.buCode === 'CTX') && x.buPermissions);
      return hasIndex > -1;
    }
    return false;
  }

  public hasDPTORCTXORTGIORVCD(): boolean {
    this.businessUnits = JSON.parse(this.getItem(Constants.LOGGED_IN_USER_INFO)).businessUnits;
    if (this.businessUnits.length) {
      const hasIndex = this.businessUnits
        .findIndex(x => (x.buCode === 'DPT' || x.buCode === 'CTX' || x.buCode === 'TGI' || x.buCode === 'VCD') && x.buPermissions);
      return hasIndex > -1;
    }
    return false;
  }

  private getBuLevelPermission() {
    const propertyName = 'buCode';
    const results = [];
    this.businessUnits = JSON.parse(this.getItem(Constants.LOGGED_IN_USER_INFO)).businessUnits;
    if (this.businessUnits.length) {
      const buCodes: string[] = this.businessUnits.map(item => item.buCode);
      const hasBuWithPermission = this.filterAndTakeFirstN(this.businessUnits, propertyName, buCodes, 1);
      for (const permission of hasBuWithPermission) {
        results.push(...permission.buPermissions.split(','));
      }
    }
    return ([...new Set(results)]);
  }

  private filterAndTakeFirstN(businessUnits: BusinessUnitDto[], propertyName: keyof BusinessUnitDto, buCodes: any[], n: number) {
    const filteredCollection = businessUnits.filter(businessUnit => buCodes.includes(businessUnit[propertyName]));
    return filteredCollection.slice(0, n);
  }
}
